import { isFinite, isNumber } from 'lodash';

export const isNumeric = (value: any) => isNumber(value) && isFinite(value);
